import { ruleRunner, run } from 'app/utils/formValidation';

const textInputValidation = value => {
  const maxTextLength = 40;
  const textLength = value.length;
  let errorMessage = `Field cannot be greater than 40 characters. (${
    maxTextLength - textLength
  })`;

  if (value.length > maxTextLength) {
    return () => errorMessage;
  }

  if (value.length === 0) {
    errorMessage = 'Field cannot be left blank';
    return () => errorMessage;
  }

  return null;
};

const dropdownValidation = (value, field) => {
  const year = field === 'startYear' ? 'start year' : 'end year';
  const errorMessage = `Please select a valid ${year}`;

  if (!value) {
    return () => errorMessage;
  }

  return null;
};

const mustBeLaterThan = (startYear, endYear) => {
  return () => {
    if (!startYear || !endYear) return null;
    const errorMessage = 'Start Year cannot be later than End Year';
    if (startYear > endYear) {
      return () => errorMessage;
    }
  };
};

const fieldValidations = values => {
  return [
    ruleRunner('name', 'Name', textInputValidation),
    ruleRunner('desc', 'Detail', textInputValidation),
    ruleRunner('startYear', 'Start Year', dropdownValidation),
    ruleRunner('endYear', 'End Year', dropdownValidation),
    ruleRunner(
      'incorrectYear',
      'Incorrect Year',
      mustBeLaterThan(values.startYear, values.endYear),
    ),
  ];
};

export const validator = values => {
  return run(values, fieldValidations(values));
};
